import { MeasurLocale } from '../locale/i18n'

export const toDateString = (datetime: string, locale: MeasurLocale) =>
  new Date(datetime).toLocaleDateString(locale, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
